// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"multi-select_wrapper__cDFCR","element":"multi-select_element__3b1tU","active":"multi-select_active__oJCph"};